var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstantScreenName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#0082FF",
    strokeWidth: 3,
    d: "M6.856.087C3.48.087.731 2.795.731 6.129v39.44c0 3.334 2.748 6.042 6.125 6.042h3.938v14.036c0 1.069.588 2.045 1.508 2.506.357.184.737.258 1.115.258.602 0 1.197-.203 1.677-.627l18.522-16.173H63.73c3.378 0 6.125-2.708 6.125-6.043V6.128c0-3.333-2.747-6.041-6.124-6.041H6.855z",
    transform: "translate(-576.000000, -283.000000) translate(577.000000, 285.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-576.000000, -283.000000) translate(577.000000, 285.000000) translate(20.500000, 11.500000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    fillRule: "nonzero",
    stroke: "#0082FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 11.5,
    r: 2,
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 11.5,
    r: 2,
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    stroke: "#0082FF",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M18.5 19s-4 2.25-8 0"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantScreenName);
export default __webpack_public_path__ + "static/media/instant-screen-name.1fde18ce25b52bafcd376a9728f4dc4e.svg";
export { ForwardRef as ReactComponent };